//Môi trường dev

export const API_URL = "https://apitest.tccrm.bdata.click/";
export const API_URL_v2 = "https://sync-thaco-dev.buso.asia"
export const API_URL_v3 = "https://apidev.berp.vn"

//Môi trường uat
// export const API_URL = "https://apiuat.tccrm.bdata.click/";
// export const API_URL_v2 = "https://sync-thaco.buso.asia"
// export const API_URL_v3 = "https://apicrm.berp.vn"

export default `${API_URL}uploads/car/`;
export const URL_TEMPLATE = `${API_URL}typeZNS/`
export const URL_TEMPLATE_IMG = `${API_URL}uploads/notification/`
export const URL_CAR_CATEGORY = `${API_URL}uploads/categoryCar/`
export const URL_CUSTOMER = `${API_URL}uploads/customer/`
export const URL_RANK = `${API_URL}uploads/rank/`

export const ICON_SUPPORT_CHANEL = `${API_URL}uploads/iconSupportChanel/`//NGUÔN
export const ICON_SUPPORT_TYPE = `${API_URL}uploads/iconSupport/`//loại
export const ICON_SATISFACTION_LEVEL = `${API_URL}uploads/iconSatisfactionLevel/`//mức độ
export const ICON_MENU = `${API_URL}uploads/iconMenu/`//mức độ

export const URL_COUNTRY = `${API_URL}uploads/country/`

export const URL_NETWORK = `${API_URL}uploads/network/`
export const URL_CHANNEL = `${API_URL}uploads/channel/`

export const URL_AVATAR = `${API_URL}uploads/account/`

export const SHOW_KEYNAME = true

export const NO_DATA = "Không xác định"
export const LIMIT_EXPORT_EXCEL = 10000
export const LOADING_MIDDLEWARE_TIMEOUT = 120000
export const IDLE_TIME_DF = 5213;
export const BATCH_SIZE = 3000;
export const MAX_DIGITS = 12;


// trường hợp luôn cho phép truy cập dù không có trong menu
export const alwaysPageAllowed = ["/customer/customer-clone-list", "/system-configuration/accounts-information", "/system-configuration/notification-email-template", '/test-drag', '/analysis-report/customers-detail', '/member-card/card-issuance-history', '/analysis-report/member-card-list', '/analysis-report/voucher-overview','/analysis-report/customers-card-list','/analysis-report/overview-complaints-grievances', '/customer/list/edit','/analysis-report/complaint-detail-list']
export const alwaysPageAllowedNotKey = [
    "/customer/group/grouping", "/marketing/notification-templates-management/edit-sms", "/marketing/notification-templates-management/editzns", "/marketing/notification-templates-management/edit-email", '/marketing/notification-templates-management/addzns', '/marketing/notification-templates-management/addemail', '/marketing/notification-templates-management/previewemail', '/marketing/notification-templates-management/previewemail2', '/customer/pooling-data/customer-list/detail-review', '/analysis-report/voucher-overview','/analysis-report/overview-complaints-grievances','/customer/list/edit','/analysis-report/complaint-detail-list'
]
